import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {RaikoMultiSelectTable,RaikoBaseCardContainer, RaikoGridOneColumn, RaikoSectionContainer} from "@moeindal/base-raiko-panel-components";

export const ManagerAccessLevelTable = ({managerId, service}) => {


    let page = 0
    const size = 15

    const serviceManagerAccessLevel = new ManagerAccessLevelService()

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [accessLevel, setAccessLevel] = useState([])
    const [selectedAccessLevels, setSelectedAccessLevels] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [roleTableLoading, setRoleTableLoading] = useState(false);

    function handleChangePagination(newPage) {
        page = newPage
        getManagerAccessLevels()
    }

    useEffect(() => {
        if (managerId >= 0) {

            service.getManagerRolesList(managerId)
                .then(response => {

                    setSelectedAccessLevels([])
                    response.map((item, index) => {
                        setSelectedAccessLevels(prevState => [
                            ...prevState,
                            {
                                name: item.title,
                                id: item.id
                            }
                        ])
                    })

                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())

            })

            if (serviceManagerAccessLevel) {
                getManagerAccessLevels()
            }
        }
    }, [])

    function getManagerAccessLevels() {
        setRoleTableLoading(true)
        serviceManagerAccessLevel.getAccessLevelList(page, size)
            .then(response => {
                setPageCount(response.totalPage)

                setAccessLevel([])
                response.data.map((item, index) => {
                    setAccessLevel(prevState => [
                        ...prevState,
                        prepareManagerAccessLevelTableRow(item.id, page * size + index + 1, item.title, item.name)
                    ])
                })

                setRoleTableLoading(false)
            }).catch(reason => {
            setRoleTableLoading(false)
            snackbar.showErrorMessage(
                new ServerErrorHandler(reason).getMessage("خطا در دریافت اطلاعات")
            )
        })
    }

    function handleUpdateManagerRoles() {
        if (selectedAccessLevels.length > 0) {
            loading.show()
            service.updateManagerRoles(managerId, selectedAccessLevels)
                .then(response => {
                    snackbar.showSuccessMessage("سطح دسترسی مدیر با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا سطح دسترسی مورد نظر را انتخاب نمایید!")
        }
    }


    return (
        <RaikoBaseCardContainer className={css`margin-top: 16px;`}>
           <RaikoGridOneColumn>
               <RaikoSectionContainer
                   title={"سطح دسترسی"}
                   hasActionButton
                   actionButtonOnclick={handleUpdateManagerRoles}
               >
                   <RaikoMultiSelectTable
                       pageCount={pageCount}
                       setSelectedItems={setSelectedAccessLevels}
                       handleChangePagination={handleChangePagination}
                       tableData={accessLevel}
                       tableHeader={managerAccessLevelHeader}
                       selectedItems={selectedAccessLevels}
                       isSingleSelect={false}
                       tableLoadingState={roleTableLoading}
                       selectedItemsTitle={""}
                       tableHintTitle={"سطح دسترسی مورد نظر را انتخاب نمایید."}
                   />
               </RaikoSectionContainer>
           </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}

export function prepareManagerAccessLevelTableRow(id, number, name, access) {
    return {
        id,
        number,
        name,
        access,
    }
}

export const managerAccessLevelHeader = [
    {
        id: 'number',
        label: '#'
    }, {
        id: 'name',
        label: 'عنوان'
    }, {
        id: 'access',
        label: 'دسترسی'
    },
]